import axios from 'axios';
import apiAxios from '../api/index';
var $base64 = require("js-base64").Base64;


// 获取优巡监控状态
export function loginStatus(examNum,personNum,cellback){
    let url_t = `${process.env.YOUXUN_URl}/cm/api/v1/person/check/online`
    axios.post(url_t, {
        examNum: examNum,
        personNum: personNum
    })
    .then(function (response) {
        cellback(response) 
    })
    .catch(function (error) {
        cellback(error)
    });
}
// 获取服务器时间
export function getDateNow(cellback){
    apiAxios.post('/date/now',{
        uid:Number($base64.decode(window.localStorage.getItem('uid-web')))
    }, response => {
        cellback(response) 
    })
}


// WEBPACK FOOTER //
// ./src/lib/youxunAPI.js